// height
export const DD_RESULTS_MIN_HEIGHT = 240; // ~ 5 items
export const DD_RESULTS_MAX_HEIGHT = 460; // ~ 10 items
export const DD_TOP_OFFSET = 10; // margin of input element
export const DD_EXTRA_HEIGHT = 105; // height of dropdown's header + footer
export const DD_HEADER_HEIGHT = 45; // height of choose or search by header
export const DD_FOOTER_HEIGHT = 60; // height of multi footer
export const PAGE_BOTTOM_OFFSET = 50; // distance we should keep from bottom of the page
export const PAGE_TOP_OFFSET = 10; // distance we should keep from top of the page
// width
export const SEARCHABLE_WIDTH = 450;
export const TWO_COLUMN_WIDTH = 350;
export const ONE_COLUMN_WIDTH = 250;
